
//
// Global Page Controller
//
// Mainly the mobile nav
//

module.exports = function GlobalController ($page, $$) {

  // Constants
  const activeClass = 'is-active';

  // Dom
  var $navicon = $$('.navicon');
  var $nav     = $$('header nav');

  // Listeners
  $navicon.click(function () {
    $nav.toggleClass('is-active');
    $navicon.toggleClass('is-active', $nav.hasClass(activeClass));
  });

}

